import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/app-marketing/secure.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
        backgroundColor: "#F9F9F9",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Secure Your Business With our Robust, and User-Focused App
              Marketing Solutions
            </h2>
            <p>
              TekRevol endeavors to transform the GCC landscape by empowering
              local businesses and bridging the technological gap within the
              local population. Through our innovative marketing strategies, we
              aim to revolutionize how businesses connect, thrive, and engage
              with the community, fostering growth and technological advancement
              in the region.
            </p>
            <p>
              As a leader in{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                mobile app development in Dubai
              </Link>
              , TekRevol is not just an app marketing company—we understand how
              technology works. From Android and iOS to hybrid mobile
              applications – we know how to assist you in getting increased
              installs, better user acquisition rates, and improved daily use
              time. We bring all this knowledge and experience to devise a
              careful and delicate timeline to put exemplary efforts into
              placing your app in front of the right people.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let's Take Your Brand Online
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
